/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconvertergenerate2Inputs */

const en_formatconvertergenerate2 = /** @type {(inputs: Formatconvertergenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert`)
};

const de_formatconvertergenerate2 = /** @type {(inputs: Formatconvertergenerate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umwandeln`)
};

/**
* | output |
* | --- |
* | "Convert" |
*
* @param {Formatconvertergenerate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconvertergenerate2 = /** @type {((inputs?: Formatconvertergenerate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconvertergenerate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconvertergenerate2(inputs)
	return de_formatconvertergenerate2(inputs)
});
export { formatconvertergenerate2 as "formatConverterGenerate" }